import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { TextInput } from 'components/Inputs';
import LoadingOverlay from 'components/LoadingOverlay';

import { H4 } from 'components/Typography';
import { BiEdit } from 'react-icons/bi';
import { isEmpty } from 'ramda';
import { AiFillCheckCircle } from 'react-icons/ai';
import { ReactComponent as CustomizeIcon } from 'products/global/assets/img/icons/av-customize.svg';
import AvatarPlaceholder from 'products/global/assets/img/icons/avatar-placeholder.png';
import { setAvatar } from '../../state';
import {
  HeaderWrapper,
  AvatarContainer,
  StyledAvatar,
  Name,
  SaveWrapper,
  Customize,
  AvatarOverlay,
  NamePlaceholder
} from './styled';
import CustomizeAvatar from '../CustomizeAvatar';

const Header = ({ formik, user, onSave, isLoading, activeProducts }) => {
  const dispatch = useDispatch();
  const { avatar } = useSelector((state) => state.app.user);
  const isAvatarLoading = useSelector((state) => state.global.profile.avatar.isLoading);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isCustomizeAvatarOpen, setIsCustomizeAvatarOpen] = useState(false);
  const { firstName, lastName } = formik?.values;

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const saveAvatar = (config) => {
    dispatch(setAvatar(config));

    setIsCustomizeAvatarOpen(false);
  };

  const headerVariants = {
    finish: {
      x: 0,
      opacity: 1,
      transition: {
        x: {
          type: 'spring',
          damping: 300
        }
      }
    },
    start: {
      x: -50,
      opacity: 0
    }
  };

  if (isEmpty(activeProducts)) {
    return null;
  }

  return (
    <>
      <CustomizeAvatar
        isOpen={isCustomizeAvatarOpen}
        onClose={() => setIsCustomizeAvatarOpen(false)}
        saveAvatar={saveAvatar}
        avatar={avatar}
        firstName={user?.firstName}
      />
      <HeaderWrapper variants={headerVariants} animate="finish" initial="start">
        <AvatarContainer
          onClick={() => setIsCustomizeAvatarOpen(true)}
          src={!avatar ? AvatarPlaceholder : null}
          background={avatar?.background}
        >
          <LoadingOverlay variant="light" size="30px" isLoading={isAvatarLoading} />

          {avatar && <StyledAvatar config={avatar} />}
          <AvatarOverlay>
            <CustomizeIcon />
            Customize
          </AvatarOverlay>
        </AvatarContainer>

        {!isEditMode && (
          <Name>
            {firstName || lastName ? (
              <H4>{`${firstName} ${lastName}`}</H4>
            ) : (
              <NamePlaceholder onClick={toggleEditMode}>Add your name</NamePlaceholder>
            )}
            <BiEdit onClick={toggleEditMode} />
          </Name>
        )}
        {isEditMode && (
          <Name>
            <TextInput
              label="First name"
              formik={formik}
              name="firstName"
              variant="light"
            />
            <TextInput
              label="Last name"
              formik={formik}
              name="lastName"
              variant="light"
            />
            <SaveWrapper onClick={() => onSave(['firstName', 'lastName'], setIsEditMode)}>
              <AiFillCheckCircle />
              <span>{isLoading ? 'Saving...' : 'Save'}</span>
            </SaveWrapper>
          </Name>
        )}

        <Customize>
          <span onClick={() => setIsCustomizeAvatarOpen(true)}>
            <CustomizeIcon /> Customize avatar
          </span>
        </Customize>
      </HeaderWrapper>
    </>
  );
};

Header.propTypes = {
  formik: PropTypes.object,
  user: PropTypes.object,
  onSave: PropTypes.func,
  isLoading: PropTypes.bool,
  activeProducts: PropTypes.array
};

export default Header;
